import { useEffect, useState } from 'react';
import { fetchBracketPreview, shareApi } from '@/lib/bracket/shareApi';

const POLL_MS = 30000;

// Loads a shared bracket and keeps it current while the page is open.
export function useSharedBracket(shareId) {
  const [share, setShare] = useState(null);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    shareApi.get(shareId, true)
      .then(async (s) => {
        const p = await fetchBracketPreview(s.format, s.num_teams);
        if (alive) { setShare(s); setPreview(p); }
      })
      .catch((e) => { if (alive) setError(e.status === 404 ? 'gone' : 'error'); });
    return () => { alive = false; };
  }, [shareId]);

  const ready = !!share;
  useEffect(() => {
    if (!ready) return undefined;
    const refresh = () => shareApi.get(shareId)
      .then((s) => setShare((prev) => (prev.updated_at === s.updated_at && prev.owner_pro === s.owner_pro
        && JSON.stringify(prev.event) === JSON.stringify(s.event) ? prev : s)))
      .catch((e) => { if (e.status === 404) setError('gone'); });
    const id = setInterval(refresh, POLL_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') refresh(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { clearInterval(id); document.removeEventListener('visibilitychange', onVisible); };
  }, [shareId, ready]);

  return { share, preview, error };
}
